import { Pipe, PipeTransform } from "@angular/core";
import { PRODUCT_NOMENCLATURE } from "../../../../constants/product-nomenclature.constant";

@Pipe({
  name: "productNomenclature",
})
export class ProductNomenclaturePipe implements PipeTransform {
  transform(value: string): string {
    if (!value || typeof value !== "string") return "";
    const trimmed = value.trim();
    const foundKey = Object.keys(PRODUCT_NOMENCLATURE).find(
      (key) => key.toLowerCase() === trimmed.toLowerCase()
    );
    return foundKey ? PRODUCT_NOMENCLATURE[foundKey] : value;
  }
}